var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 445,
    height: 337.648,
    viewBox: "0 0 445 337.648",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1740",
    "data-name": "Group 1740",
    transform: "translate(-1236.159 -126)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3166",
    "data-name": "Path 3166",
    d: "M626.739,454.63H222.364a20.313,20.313,0,0,1-20.312-20.313V211.629a20.313,20.313,0,0,1,20.312-20.313H626.739a20.314,20.314,0,0,1,20.313,20.313V434.316a20.314,20.314,0,0,1-20.313,20.313",
    transform: "translate(1034.107 -18.297)",
    fill: "#21cfa9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_310",
    "data-name": "Ellipse 310",
    cx: 5.364,
    cy: 5.364,
    rx: 5.364,
    ry: 5.364,
    transform: "translate(1248.671 193.099) rotate(-76.717)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_311",
    "data-name": "Ellipse 311",
    cx: 5.364,
    cy: 5.364,
    rx: 5.364,
    ry: 5.364,
    transform: "translate(1266.722 193.099) rotate(-76.717)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_312",
    "data-name": "Ellipse 312",
    cx: 5.364,
    cy: 5.364,
    rx: 5.364,
    ry: 5.364,
    transform: "translate(1284.774 193.099) rotate(-76.717)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3167",
    "data-name": "Path 3167",
    d: "M328.827,315.73c8.4,5.4,12.694,11.115,13.313,15.335,0,0,183.672,69.976,232.016,34.7,39.135-28.558-.8-59.927-12.824-62.6-22.622-5.027-23.879-6.284-13.824-30.163s24.258-37.917-11.312-41.473c-25.135-2.514-26.392-10.055-27.649-38.961s-46.5-32.677-62.839-25.135,0-11.312-15.082-15.081-18.851,5.027-21.365,11.311-33.933,8.8-40.216,31.42-31.42,20.108-22.622,57.812-3.771,22.622-13.825,26.392-21.365,25.136-3.771,36.447",
    transform: "translate(1055.173 -25.441)",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3168",
    "data-name": "Path 3168",
    d: "M297.791,433.225,318.8,330.81a50.7,50.7,0,0,1,43.687-23.657l141-3.176a44.791,44.791,0,0,1,43.674,31.146L579.708,434.4",
    transform: "translate(1051.259 1.886)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3169",
    "data-name": "Path 3169",
    d: "M297.791,433.225,318.8,330.81a50.7,50.7,0,0,1,43.687-23.657l141-3.176a44.791,44.791,0,0,1,43.674,31.146L579.708,434.4",
    transform: "translate(1051.259 1.886)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3170",
    "data-name": "Path 3170",
    d: "M468.258,222.636a64.887,64.887,0,1,1-64.887-64.887,64.887,64.887,0,0,1,64.887,64.887",
    transform: "translate(1058.55 -24.311)",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3171",
    "data-name": "Path 3171",
    d: "M478.946,241.628a16.581,16.581,0,0,0-8.273.406,56.368,56.368,0,0,0-107.107-32.916L356.636,225.1a43.69,43.69,0,0,0,31.658,60.247l4.982.98v41.738H368.343c8.4,23.073,31.626,39.666,58.982,39.666s50.58-16.593,58.982-39.666H455.8V284.805a30.112,30.112,0,0,0,7.886-14l.245-.987a16.652,16.652,0,1,0,15.012-28.193",
    transform: "translate(1061.152 -21.196)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3172",
    "data-name": "Path 3172",
    d: "M478.946,241.628a16.581,16.581,0,0,0-8.273.406,56.368,56.368,0,0,0-107.107-32.916L356.636,225.1a43.69,43.69,0,0,0,31.658,60.247l4.982.98v41.738H368.343c8.4,23.073,31.626,39.666,58.982,39.666s50.58-16.593,58.982-39.666H455.8V284.805a30.112,30.112,0,0,0,7.886-14l.245-.987a16.652,16.652,0,1,0,15.012-28.193Z",
    transform: "translate(1061.152 -21.196)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3173",
    "data-name": "Path 3173",
    d: "M450.275,249.244a12.3,12.3,0,0,1,14.521-9.577",
    transform: "translate(1078.579 -9.68)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3174",
    "data-name": "Path 3174",
    d: "M372.826,189.471c11.2-5.175,17.309-.057,17.309-.057a14.642,14.642,0,0,1,2.894,21.941l-9.2,10.375",
    transform: "translate(1064.703 -19.042)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3175",
    "data-name": "Path 3175",
    d: "M421.711,213.077c-2.065,2.65-5.05,3.4-6.666,1.68s-1.252-5.265.812-7.914,5.05-3.4,6.666-1.68,1.252,5.265-.812,7.915",
    transform: "translate(1072.086 -15.982)",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3176",
    "data-name": "Path 3176",
    d: "M381.983,203.859c-2.066,2.65-5.055,3.4-6.675,1.676s-1.258-5.269.808-7.918,5.054-3.4,6.675-1.676,1.258,5.269-.808,7.918",
    transform: "translate(1064.966 -17.635)",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3177",
    "data-name": "Path 3177",
    d: "M379.9,223.115l31.359.156s-16.866,36.3-31.359-.156",
    transform: "translate(1065.971 -12.6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3178",
    "data-name": "Path 3178",
    d: "M379.9,223.115l31.359.156S394.4,259.572,379.9,223.115Z",
    transform: "translate(1065.971 -12.6)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3179",
    "data-name": "Path 3179",
    d: "M457.705,238.828a56.3,56.3,0,0,0-30.339-58.53c-1.378,22.27,10.444,43.92,30.339,58.53",
    transform: "translate(1074.455 -20.271)",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3180",
    "data-name": "Path 3180",
    d: "M412.77,193.927s21.118,1.553,26.779,19.28",
    transform: "translate(1071.859 -17.829)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3181",
    "data-name": "Path 3181",
    d: "M418.311,261.775s-19.469,8.547-31.153,9.032",
    transform: "translate(1067.271 -5.674)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3182",
    "data-name": "Path 3182",
    d: "M509.892,418.439s-34.916-37.732-84.572-26.464c-39.794,9.03-47.429,31.975-33.574,39.818,4.7,2.658,18.828-1.7,18.828-1.7s2.573,6.27,9.5,4.917c7.613-1.488,7.555,6.208,11.6,9.473,4.266,3.445,10.983-.083,13.145-4.849s14.117-16.469,14.117-16.469-.149,10.426,3.618,15.735c2.582,3.639,11.2.321,16.086-6.231,8.267-11.072,3.561-16.824,31.258-14.231",
    transform: "translate(1066.95 17.277)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3183",
    "data-name": "Path 3183",
    d: "M429.83,390.679s-24.361,21-22.655,36.908c1.225,11.409,14.437,6.834,14.437,6.834",
    transform: "translate(1070.842 17.421)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3184",
    "data-name": "Path 3184",
    d: "M429.83,390.679s-24.361,21-22.655,36.908c1.225,11.409,14.437,6.834,14.437,6.834",
    transform: "translate(1070.842 17.421)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3185",
    "data-name": "Path 3185",
    d: "M450.453,392.1c-16.743,11.807-37,41.437-27.346,49.777,9.8,8.469,15.547-2.667,19.206-7.679a93.42,93.42,0,0,1,11.254-12.5",
    transform: "translate(1073.263 17.676)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3186",
    "data-name": "Path 3186",
    d: "M450.453,392.1c-16.743,11.807-37,41.437-27.346,49.777,9.8,8.469,15.547-2.667,19.206-7.679a93.42,93.42,0,0,1,11.254-12.5",
    transform: "translate(1073.263 17.676)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3187",
    "data-name": "Path 3187",
    d: "M472.166,405.253s-21.428,22.441-10.154,32C471.159,445,477.47,434.1,477.47,434.1l10.259-15.544,23.886-.152s-42.973-49.692-105.66-18.579c-36.139,17.937-13.2,32.5-13.2,32.5s10.779,1.795,18.272-4.547",
    transform: "translate(1066.987 17.225)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3188",
    "data-name": "Path 3188",
    d: "M267.69,436.565l21.4-51.468-75.319-73.278a5.552,5.552,0,0,1,.047-8,10.443,10.443,0,0,1,13.488-.763l44.11,33.324,45.625.229-8.094-31.927a10.256,10.256,0,0,1,19.177-6.981l20.5,42.454a62.985,62.985,0,0,1,2.981,47.477l-14.973,48.935",
    transform: "translate(1035.905 -0.276)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3189",
    "data-name": "Path 3189",
    d: "M267.69,436.565l21.4-51.468-75.319-73.278a5.552,5.552,0,0,1,.047-8,10.443,10.443,0,0,1,13.488-.763l44.11,33.324,45.625.229-8.094-31.927a10.256,10.256,0,0,1,19.177-6.981l20.5,42.454a62.985,62.985,0,0,1,2.981,47.477l-14.973,48.935",
    transform: "translate(1035.905 -0.276)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3190",
    "data-name": "Path 3190",
    d: "M244.453,332.054l-9.772-38.839a4.539,4.539,0,0,1,6.08-5.325,16.833,16.833,0,0,1,9.513,9.661L265.354,334",
    transform: "translate(1039.928 -1.054)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3191",
    "data-name": "Path 3191",
    d: "M244.453,332.054l-9.772-38.839a4.539,4.539,0,0,1,6.08-5.325,16.833,16.833,0,0,1,9.513,9.661L265.354,334",
    transform: "translate(1039.928 -1.054)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3192",
    "data-name": "Path 3192",
    d: "M302.353,368.137,277.5,344.554l-6.818-37.207a14.628,14.628,0,0,0-9.314-11.084,4.684,4.684,0,0,0-6.3,4.579l1.836,46.392",
    transform: "translate(1043.603 0.453)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3193",
    "data-name": "Path 3193",
    d: "M302.353,368.137,277.5,344.554l-6.818-37.207a14.628,14.628,0,0,0-9.314-11.084,4.684,4.684,0,0,0-6.3,4.579l1.836,46.392",
    transform: "translate(1043.603 0.453)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2799",
    "data-name": "Rectangle 2799",
    width: 28.583,
    height: 28.584,
    transform: "translate(1263.294 233.983)",
    fill: "none",
    stroke: "#080717",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_111",
    "data-name": "Line 111",
    y1: 28.584,
    x2: 28.583,
    transform: "translate(1263.294 233.983)",
    fill: "none",
    stroke: "#080717",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_112",
    "data-name": "Line 112",
    x2: 28.583,
    y2: 28.584,
    transform: "translate(1263.294 233.983)",
    fill: "none",
    stroke: "#080717",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_113",
    "data-name": "Line 113",
    x2: 57.877,
    transform: "translate(1303.004 233.994)",
    fill: "none",
    stroke: "#080717",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_114",
    "data-name": "Line 114",
    x2: 57.877,
    transform: "translate(1303.004 244.78)",
    fill: "none",
    stroke: "#080717",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_115",
    "data-name": "Line 115",
    x2: 42.862,
    transform: "translate(1303.004 255.566)",
    fill: "none",
    stroke: "#080717",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage2);
export default __webpack_public_path__ + "static/media/image2.40f43a66b110524757aa7cdff77e2b0d.svg";
export { ForwardRef as ReactComponent };